import { useEffect, useMemo, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import Table from "../../core/common/dataTable/index";
import AXIOSCONFIGMETHOD from '../../Axios/axiosConfigMethod';
import { webServiceUrl } from '../../core/api_utils/webserviceUrl';
import Loading from '../../core/common/custom-loading/Loading';
import SearchSelect from '../../core/common/search-select/searchSelect';
import CommonSelect2 from '../../core/common/commonSelect2';


const AllBookings = () => {
    const [loading, setLoading] = useState(false);
    const [allItemList, setAllItemList] = useState<any[]>([]);
    const [allOrganizations, setAllOrganizations] = useState<any[]>([]);
    const [orgId, setOrgId] = useState("");
    const stored_orgId = localStorage.getItem("org-id");
    const routes = all_routes;
    // const originalId = atob(orgid || "");

    const options_organization: any[] = useMemo(
        () =>
            allOrganizations?.map((item) => ({
                value: `${item.organization_id}`,
                label: `${item.organization_name}`,
            })),
        [allOrganizations]
    );

    const columns = [
        {
            title: "Sr No.",
            dataIndex: "SrNo",
            render: (text: string, record: any, index: number) => (
                <h6 className="fw-medium fs-14 text-dark" >{index + 1}</h6>
            ),
            // sorter: (a: any, b: any) => a.SrNo - b.SrNo,
            sorter: false,
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text}</p>
            ),
            sorter: (a: any, b: any) => (a.status || "").localeCompare(b.status || ""),
        },
        {
            title: "Token Paid",
            dataIndex: "is_token_amountpaid",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.is_token_amountpaid) - (b.is_token_amountpaid),
        },
        {
            title: "Token Amount",
            dataIndex: "token_amount",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.token_amount || "").localeCompare(b.token_amount || ""),
        },
        {
            title: "Property Name",
            dataIndex: "property_name",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.property_name || "").localeCompare(b.property_name || ""),
        },
        {
            title: "Property Type",
            dataIndex: "property_type_id",
            render: (text: string, record: any) => {
                return <p >{text ?? "-"}</p>
            },
            sorter: (a: any, b: any) => a.property_type_id - b.property_type_id,
        },
        {
            title: "Flat/Block No.",
            dataIndex: "house_flat_block_no",
            render: (text: string, record: any) => {
                return <p >{text ?? "-"}</p>
            },
            sorter: (a: any, b: any) => a.house_flat_block_no - b.house_flat_block_no,
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            render: (text: string, record: any) => {
                return <p >{text ?? "-"}</p>
            },
            sorter: (a: any, b: any) => a.pincode - b.pincode,
        },
        {
            title: "Booking Status",
            dataIndex: "booking_status",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.booking_status || "").localeCompare(b.booking_status || ""),
        },
        {
            title: "Booking Amount",
            dataIndex: "booking_amount",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.booking_amount - b.booking_amount,
        },
        {
            title: "Security Amount",
            dataIndex: "security_deposit_amount",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.security_deposit_amount - b.security_deposit_amount,
        },
        {
            title: "Rental Type",
            dataIndex: "rental_type_enum_id",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.rental_type_enum_id || "").localeCompare(b.rental_type_enum_id || ""),
        },
        {
            title: "Monthly Rent",
            dataIndex: "rental_amount",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.rental_amount || "").localeCompare(b.rental_amount || ""),
        },
        {
            title: "Payment Status",
            dataIndex: "payment_status",
            render: (text: string, record: any,) => (
                <p className="fw-medium fs-14 text-dark" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.payment_status || "").localeCompare(b.payment_status || ""),
        },
        {
            title: "Late Fine Applicable ",
            dataIndex: "late_fine_applicable",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.late_fine_applicable || "").localeCompare(b.late_fine_applicable || ""),
        },
        {
            title: "Late Fine Amount",
            dataIndex: "late_fine_amount",
            render: (text: number, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.late_fine_amount - b.late_fine_amount,
        },
        {
            title: "Extra Charge Applicable",
            dataIndex: "extra_charge_applicable",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.extra_charge_applicable || "").localeCompare(b.extra_charge_applicable || ""),
        },
        {
            title: "Extra Charge Amount",
            dataIndex: "extra_charge_amount",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.extra_charge_amount || "").localeCompare(b.extra_charge_amount || ""),
        },
        {
            title: "Security (Months)",
            dataIndex: "security_deposit_months",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.security_deposit_months || "").localeCompare(b.security_deposit_months || ""),
        },
        {
            title: "Agreement Duration (Months)",
            dataIndex: "agreement_duration_months",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.agreement_duration_months || "").localeCompare(b.agreement_duration_months || ""),
        },
        {
            title: "Lock-in Period (Months)",
            dataIndex: "lock_in_period_months",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.lock_in_period_months || "").localeCompare(b.lock_in_period_months || ""),
        },
        {
            title: " Notice Period (Months)",
            dataIndex: "notice_period_months",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.notice_period_months || "").localeCompare(b.notice_period_months || ""),
        },
        {
            title: "Actual Check-in",
            dataIndex: "actual_check_in_date",
            render: (text: string, record: any,) => (
                <p className="" >{text}</p>
            ),
            sorter: (a: any, b: any) => (a.actual_check_in_date || "").localeCompare(b.actual_check_in_date || ""),
        },
        {
            title: "Actual Check-out",
            dataIndex: "actual_check_out_date",
            render: (text: string, record: any,) => (
                <p className="" >{text}</p>
            ),
            sorter: (a: any, b: any) => (a.actual_check_out_date || "").localeCompare(b.actual_check_out_date || ""),
        },
        {
            title: "Agreement start Date",
            dataIndex: "agreement_start_date",
            render: (text: string, record: any,) => (
                <p className="" >{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) =>
                new Date(a.agreement_start_date).getTime() - new Date(b.agreement_start_date).getTime(),
        },
        {
            title: "Agreement End Date",
            dataIndex: "agreement_end_date",
            render: (text: string, record: any,) => (
                <p className="" >{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) =>
                new Date(a.agreement_end_date).getTime() - new Date(b.agreement_end_date).getTime(),
        },
        {
            title: "Approval Status",
            dataIndex: "approval_status",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => (a.approval_status || "").localeCompare(b.approval_status || ""),
        },
        {
            title: "Created On",
            dataIndex: "created_at",
            render: (text: string, record: any,) => (
                <p className="" >{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) =>
                new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
        },
        {
            title: "Updated On",
            dataIndex: "updated_at",
            render: (text: string, record: any,) => (
                <p className="" >{text?.split("T")[0] ?? "-"}</p>
            ),
            sorter: (a: any, b: any) =>
                new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime(),
        },
        {
            title: "Room No.",
            dataIndex: "room_number",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.room_number - b.room_number,
        },
        {
            title: "Total Beds",
            dataIndex: "unit_number",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.unit_number - b.unit_number,
        },
        {
            title: "Rent Type",
            dataIndex: "rent_type_enum_id",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.rent_type_enum_id - b.rent_type_enum_id,
        },
        {
            title: "Maintenance Amount",
            dataIndex: "maintainance_amt",
            render: (text: string, record: any,) => (
                <p className="text-capitalize" >{text ?? "-"}</p>
            ),
            sorter: (a: any, b: any) => a.maintainance_amt - b.maintainance_amt,
        },
    ];

    const fetchData = async (id?: string) => {
        // const payload = { organization_id: id };
        try {
            setLoading(true)
            const resp = await AXIOSCONFIGMETHOD("post", webServiceUrl.VIEW_BOOKING);

            if (resp?.success) {
                const final = resp?.data;
                setAllItemList(Array.isArray(final) ? final : []);
            }
        } catch (error) {
            console.error("Error fetching  data:", error);
        } finally {
            setTimeout(() => setLoading(false), 500);
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    // function searchProperties() {
    //     localStorage.removeItem('org-id');
    //     fetchData(orgId)
    // }

    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">All Bookings</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Dashboard
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        All Booking List
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            {/* <div className="mb-2">
                                <button
                                    className="btn btn-primary d-flex align-items-center"
                                    disabled={loading}
                                >
                                    <i className="ti ti-circle-plus me-2" />
                                    Add New Band
                                </button>
                            </div> */}
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* <div className="col-md-12 mb-3 bg-white border p-3 shadow-sm rounded-3">
                        <label className='pb-2 fw-medium fs-15 d-block'>Select Organization:</label>
                        <CommonSelect2 className='d-inline ' options={options_organization} name='organization' defaultValue={orgId} onChange={(e: any) => setOrgId(e?.value)} styles={{ maxWidth: "500px" }} />
                        <button className='btn btn-primary px-3 ms-2' onClick={searchProperties}> <i className="bi bi-search me-sm-1"></i><span className='d-none d-sm-inline'>Search</span></button>
                    </div> */}

                    {/* Performance Indicator list */}
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Booking List</h5>
                        </div>
                        <div className="card-body p-0">
                            {loading
                                ? <Loading />
                                : <Table dataSource={allItemList} rowKeyId={"Staff_id"} columns={columns} Selection={false} />
                            }
                        </div>
                    </div>
                    {/* /Performance Indicator list */}
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
               <p className="mb-0">© {new Date().getFullYear()} Nestfin Technology. All rights reserved.</p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    )
}

export default AllBookings;